import { GetterTree } from "vuex";
import { IProcessUserState } from "@/store/modules/processUser/state";
import ProcessUser from "@/types/documents/process/ProcessUser";

import { IDataProvider, IRootState } from "@/store";

export enum ProcessUserGetters {
  GET_ALL = "GET_ALL_PROCESS_USER",
  GET_CURRENT = "GET_CURRENT_PROCESS_USER",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_PROCESS_USER",
}

export const getters: GetterTree<IProcessUserState, IRootState> = {
  [ProcessUserGetters.GET_ALL](state): ProcessUser[] | null {
    return state.processUsers;
  },
  [ProcessUserGetters.GET_CURRENT](state): ProcessUser | null {
    return state.processUser;
  },
  [ProcessUserGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<ProcessUser> | null {
    return state.dataProvider;
  },
};
